<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Set Deadline
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <div id="slideout-container">
      <v-stepper v-model="e1" class="no-transition" alt-labels non-linear>
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Select Users</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2">Select Groups</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3">Set Deadline</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" class="max-height-list scroll-y">
            <v-text-field
              v-model="search"
              label="Filter Users By Name"
              type="text"
              @change="applyUserSearch"
            ></v-text-field>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="users"
              item-key="id"
              show-select
              class="enrol-user-list-tbl"
              :footer-props="{
              'items-per-page-options': [5,10,15]
              }"
            ></v-data-table>
          </v-stepper-content>
          <v-stepper-content step="2" class="max-height-list scroll-y">
            <div style="border:1px solid rgba(0, 0, 0, 0.12);">
                <v-text-field
                v-model="groupSearch"
                label="Filter Groups By Name"
                type="text"
                @change="applyGroupSearch"
                append-icon="fa-search"
                class="filter-user"
                ></v-text-field>
                <v-expansion-panels accordion 
                v-model="panel"
                multiple>
                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Groups Assigned</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-skeleton-loader v-if="groupLoading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                          <v-skeleton-loader v-if="groupLoading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                          <v-data-table
                            v-model="selectedGroups"
                            :headers="groupHeaders"
                            :options.sync="groupOptions"
                            :server-items-length="serverGroupItemsLength"
                            v-show="!groupLoading"
                            :items="groups"
                            item-key="id"
                            show-select
                            class="mb-5 enrol-user-list-tbl"
                            :footer-props="{
                            'items-per-page-options': [5,10,15]
                            }"
                            ></v-data-table>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </v-stepper-content>
          <v-stepper-content step="3" class="max-height-list scroll-y">
            <date-picker :color="datePickerColor"></date-picker>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <div v-if="e1 == 1">
          <v-btn color="grey300" class="mr-4 cancel-button"  @click="closePanel">Cancel</v-btn>
          <v-btn color="dark-blue" class="add-course-button" @click="e1 = 2">Next</v-btn>
        </div>
        <div v-if="e1 == 2">
            <v-btn v-if="!loading" color="grey300" class="mr-4" @click="e1 = 1">Back</v-btn>
            <v-btn v-if="loading" color="primary" loading></v-btn>
            <v-btn v-else color="dark-blue" class="add-course-button" @click="e1 = 3">Next</v-btn>
        </div>
        <div v-if="e1 == 3">
          <v-btn v-if="!loading" color="grey300" class="mr-4 cancel-button" @click="e1 = 2">Back</v-btn>
          <v-btn v-if="loading" color="primary" loading></v-btn>
          <v-btn v-else color="dark-blue" class="add-course-button" @click="updateDeadline">Update Deadline</v-btn>
        </div>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";
import DatePicker from "@/components/admin/global/Datepicker";
export default {
  name: "ManageDeadlines",
  components: {
    DatePicker
  },
  props: {
    id: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      el: '#app',
      date: new Date().toISOString().substr(0, 10),
      headers: [
        { text: "First Name", value: "first_name" },
        { text: "Surname", value: "last_name" },
        { text: "Email", value: "email" },
        { text: "Deadline", value: "usercourses.deadline_formatted" },
      ],
      loading: false,
      e1: 1,
      selected: [],
      search: "",
      users: [],
      searchParams: "",
      options: {},
      pagination: {},
      selectedDate: "Not Set",
      deadlineSet: false,
      successMessage: "Users Successfully Enrolled.",
      errorMessage: "Oops, something went wrong!",
      nothingSelected: "You havent selected any Users or Groups.",
      deadlineNotSet: "You havent set a Deadline.",
      groups: [],
      userSearchParams: "",
      groupSearchParams: "",
      groupSearch: "",
      panel: [0,1],
      selectedGroups: [],
      groupHeaders: [
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "Deadline", value: "groupcourses.deadline_formatted" },
      ],
      groupOptions: {},
      groupLoading: false,
      groupPagination: {}
    };
  },
  computed: {
    serverItemsLength: function() {
      return this.pagination.total;
    },
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.options);
    },
    selectedTotal: function() {
      return this.selected.length;
    },
    serverGroupItemsLength: function() {
      return this.groupPagination.total;
    },
    groupParams: function() {
        return this.$gf.getQueryString(this.groupOptions);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    datePickerColor() {
      return this.$gf.headerColor();
    },
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true
    },
    groupOptions: {
      handler() {
        this.getGroups();
      },
      deep: true
    },
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    getUsers() {
      this.loading = true;
      courseAPI
        .getCourseEnrolledUsers(this.id, this.params + "&include=usercourses", this.searchParams)
        .then(resp => {
          //this.users = resp.data.data;
          this.users = [];
          resp.data.data.forEach(item => {
            item.usercourses = item.usercourses.data.filter(userCourse => {
              return userCourse.course_id == this.id;
            });
            item.usercourses = item.usercourses[0];
            this.users.push(item);
          });
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    applyUserSearch() {
      let search = this.search ? this.search : '';
      this.searchParams =
      "&search=first_name:" +
      this.search +
      ";last_name:" +
      this.search;
      this.getUsers();
    },
    processSelected() {
      let users = [];
      this.selected.forEach(function(x) {
        users.push(x.id);
      });
      return users;
    },
    processSelectedGroups() {
      let groups = [];
      this.selectedGroups.forEach(function(x) {
        groups.push(x.id);
      });
      return groups;
    },
    process() {
      this.loading = true;
      courseAPI
        .updateDeadline(this.id, {
          users: this.processSelected(),
          groups: this.processSelectedGroups(),
          selectedDate: this.selectedDate
        })
        .then(() => {
          EventBus.$emit("COURSES_UPDATED", this.params);
          this.closePanel();
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    contine(toast) {
      this.$snotify.remove(toast.id);
      this.selectedDate = "";
      this.process();
    },
    setADate(toast) {
      this.$snotify.remove(toast.id);
      this.loading = false;
      this.el = 3;
    },
    updateDeadline() {
      // this.selectedDate = "";
      this.process();
    },
    setEventBus() {
      EventBus.$on("DATE_SELECTED", date => {
        this.deadlineSet = true;
        this.selectedDate = date;
      });
    },
    closePanel() {
      this.$emit("closePanel", {});
    },
    applyGroupSearch() {
      this.getGroups();
    },
    getGroups() {
      this.groupLoading = true;
      let parameter = this.groupParams + "&include=groupcourses";
      if(this.groupSearch) {
        parameter = parameter + "&search=name:" + this.groupSearch;
      }
      courseAPI
      .getCourseEnrolledGroups(
          this.id,
          parameter
          )
      .then(resp => {
        this.groupLoading = false;
        this.groups = [];
        let responseData = resp.data.data;
        responseData.forEach(item => {
          if(item.groupcourses) {
            item.groupcourses = item.groupcourses.data.filter(groupCourse => {
              return groupCourse.course_id == this.id;
            });
            item.groupcourses = item.groupcourses[0];
            this.groups.push(item);
          } else {
            this.groups = responseData;
          }
        });
        this.groupPagination = resp.data.meta.pagination;
      });
    },
  }
};
</script>
<style media="screen">
#slideout-container {
  height: calc(100vh - 65px - 100px);
}
.max-height-list {
  height: calc(100vh - 65px - 100px - 48px);
}
.no-transition .stepper__content {
  transition: none;
}


.date-color {
  color: #00B300;
  font-weight: 900;
}

.v-btn--active .date-color {
  color: #fff;
}
</style>
